import { KyInstance } from 'ky';

import { buildSearchParams, handleBlobRequest, handleRequest } from '@/utils/httpUtils';

import type {
  CreateArrival,
  CreateKit,
  CreateOrder,
  ImportProducts,
  OverallStats,
  OverallStatsResponse,
  ProductResponse,
  Products,
  ReportsProducts,
  TemplateProducts,
  TemplateProductsResponse,
  UpdateProduct,
  UpdateProductResponse,
  UploadImage,
  UploadImageResponse,
} from './types';

export interface IReqInventory {
  products: Products;
  templateProducts: TemplateProducts;
  importProducts: ImportProducts;
  overallStats: OverallStats;
  updateProduct: UpdateProduct;
  uploadImage: UploadImage;
  createArrival: CreateArrival;
  createOrder: CreateOrder;
  reportProducts: ReportsProducts;
  createKit: CreateKit;
}

export function reqInventory(http: KyInstance): IReqInventory {
  const route = 'api/v1';
  return {
    products: (ars) =>
      handleRequest<ProductResponse>(http, 'get', `${route}/products`, {
        searchParams: buildSearchParams(ars),
      }),
    templateProducts: (ars) =>
      handleRequest<TemplateProductsResponse>(http, 'post', `${route}/products/template`, {
        body: ars,
      }),
    importProducts: (ars) =>
      handleRequest(http, 'post', `${route}/products/import`, {
        body: ars,
      }),
    overallStats: () =>
      handleRequest<OverallStatsResponse>(http, 'get', `${route}/stats/overall-stats`),
    updateProduct: ({ sku, ...ars }) =>
      handleRequest<UpdateProductResponse>(
        http,
        'patch',
        `${route}/products/${encodeURIComponent(sku)}`,
        {
          json: ars,
        },
      ),
    uploadImage: (ars) =>
      handleRequest<UploadImageResponse>(
        http,
        'patch',
        `${route}/products/${encodeURIComponent(ars.sku)}/upload-image`,
        {
          body: ars.images,
        },
      ),
    createArrival: (ars) => handleRequest(http, 'post', `${route}/arrival-orders`, { json: ars }),
    createOrder: (ars) => handleRequest(http, 'post', `${route}/orders`, { json: ars }),
    createKit: (ars) =>
      handleRequest(http, 'post', `${route}/products/kit`, {
        json: ars,
        headers: { 'x-api-version': 'auth0' },
      }),
    reportProducts: (ars) =>
      handleBlobRequest(http, 'get', `${route}/downloads/products/report`, {
        searchParams: buildSearchParams({ ...(ars ?? {}), _t: Date.now() }),
        cache: 'no-store',
      }),
  };
}
